export const signInImage = "../doctor.jpg";
export const drawerWidth: number = 240;
export const settings = [
  { text: "Profile", url: "/profile" },
  { text: "Dashboard", url: "/dashboard" },
  {
    text: "Logout", url: "/login", onClick: () => {
      localStorage.clear();
      window.location.reload()
    }
  }
];
